<template>
  <app-layout>
    <v-container fluid>
      <admin-calendar-events></admin-calendar-events>
    </v-container>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import AdminCalendarEvents from '../components/AdminCalendarEvents.vue';

export default {
  components: {
    AppLayout,
    AdminCalendarEvents,
  },
};
</script>
